import {
    usePlainList
  } from '@inmagik/react-crud'
  import { API_URL } from '../constants'
import { Provincia } from '../types'
  
  export function useProvinceList(params: Record<string, string> = {}) {
    return usePlainList<Provincia>(`${API_URL}/bilance/provincia`, params)
  }
  